module.exports = __webpack_public_path__ + "static/img/avatar.676165a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = HfaK
// module chunks = 101